<template>
    <div>
      <payment-list></payment-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>